var anchoventana=$(document).width();
var altoventana=$(document).height();
var md=768;

(function($) {
  var Sage = {
    'common': {
      init: function() {
        /**
         * declaracion variables globales
         */

         /**
          * init plugins y listeners comunes de proyectos
          */
         initPlugins();
         initListeners();

        /**
         * js del proyecto
         */


        $(".js-calcularDosis").click(function(){
          
          var peso=$("#peso").val();

          var dosisdia="";
          var dosisnoche="";
          var dosisobjetivo75="";
          var dosisobjetivo25="";
          var dosisinicial16_75="";
          var dosisinicial16_25="";
          var dosisinicial14_75="";
          var dosisinicial14_25="";

          if (isNaN(peso) || peso=="" ){
            
            PLG_showModalAlerta("Error","Por favor, introduce un valor numérico válido");

          }else{

              if (peso<=5){
                
                dosisdia=200;
                dosisnoche=200;
                dosisobjetivo75=2;
                dosisobjetivo25=2;
                dosisinicial16_75=0;
                dosisinicial16_25=1;
                dosisinicial14_75=0;
                dosisinicial14_25=2;
                console.log("menor que 5");

              }else{

                if (peso<=10){
                
                  dosisdia=300;
                  dosisnoche=300;
                  dosisobjetivo75=4;
                  dosisobjetivo25=0;
                  dosisinicial16_75=0;
                  dosisinicial16_25=2;
                  dosisinicial14_75=1;
                  dosisinicial14_25=0;
  
                }else{

                  if (peso<=15){
                  
                    dosisdia=400;
                    dosisnoche=400;
                    dosisobjetivo75=5;
                    dosisobjetivo25=1;
                    dosisinicial16_75=1;
                    dosisinicial16_25=0;
                    dosisinicial14_75=1;
                    dosisinicial14_25=1;              
    
                  }else{

                    if (peso<=20){
                    
                      dosisdia=500;
                      dosisnoche=500;
                      dosisobjetivo75=6;
                      dosisobjetivo25=2;
                      dosisinicial16_75=1;
                      dosisinicial16_25=1;
                      dosisinicial14_75=1;
                      dosisinicial14_25=2;               
      
                    }else{

                      if (peso<=25){
                      
                        dosisdia=600;
                        dosisnoche=600;
                        dosisobjetivo75=8;
                        dosisobjetivo25=0;
                        dosisinicial16_75=1;
                        dosisinicial16_25=1;
                        dosisinicial14_75=2;
                        dosisinicial14_25=0;               
        
                      }else{

                        if (peso<=30){

                          dosisdia=700;
                          dosisnoche=700;
                          dosisobjetivo75=9;
                          dosisobjetivo25=1;
                          dosisinicial16_75=1;
                          dosisinicial16_25=2;
                          dosisinicial14_75=2;
                          dosisinicial14_25=1; 

                        }else{

                          if (peso<=40){

                            dosisdia=800;
                            dosisnoche=800;
                            dosisobjetivo75=10;
                            dosisobjetivo25=2;
                            dosisinicial16_75=1;
                            dosisinicial16_25=2;
                            dosisinicial14_75=2;
                            dosisinicial14_25=2; 

                          }else{

                            if (peso<=50){

                              dosisdia=900;
                              dosisnoche=900;
                              dosisobjetivo75=12;
                              dosisobjetivo25=0;
                              dosisinicial16_75=2;
                              dosisinicial16_25=0;
                              dosisinicial14_75=3;
                              dosisinicial14_25=0;                               

                            }else{

                              dosisdia=1000;
                              dosisnoche=1000;
                              dosisobjetivo75=13;
                              dosisobjetivo25=1;
                              dosisinicial16_75=2;
                              dosisinicial16_25=1;
                              dosisinicial14_75=3;
                              dosisinicial14_25=1;                               

                            }

                          }

                        }

                      }                     
                    
                    }

                  }

                }
  
              }

             


            $("#dosisdia").html(dosisdia);
            $("#dosisnoche").html(dosisnoche);
            $("#dosisobjetivo75").html(dosisobjetivo75);
            $("#dosisobjetivo25").html(dosisobjetivo25);
            $("#dosisinicial16_75").html(dosisinicial16_75);
            $("#dosisinicial16_25").html(dosisinicial16_25);
            $("#dosisinicial14_75").html(dosisinicial14_75);
            $("#dosisinicial14_25").html(dosisinicial14_25);

            $("#resultado").slideDown();

            $("html, body").animate({ scrollTop: $('#resultado').offset().top }, 1000);

          }


        })


      },
      finalize: function() {
      }
    },
  };
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.